import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-ui-components-radio-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './radio-button.component.html',
  styleUrl: './radio-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioButtonComponent {
  // Inputs
  size = input<16 | 20 | 24>(20);
  disabled = input<boolean>(false);

  // Models
  checked = model<boolean>(false);
  wrapperCLasses = computed(() => this.generateWrapperClasses());

  handleCheck(): void {
    if (!this.disabled()) {
      this.checked.set(!this.checked());
    }
  }

  generateWrapperClasses(): string {
    const sizeClassMap = {
      16: ['border-6', 'border-300'],
      20: ['border-7', 'border-400'],
      24: ['border-8', 'border-500'],
    };

    let colorClass;
    if (this.disabled()) {
      colorClass = this.checked() ? 'border-color-disabled' : 'border-color-air';
    } else {
      colorClass = this.checked() ? 'border-color-brand' : 'border-color-tint';
    }
    return `${colorClass} ${sizeClassMap[this.size()][this.checked() ? 0 : 1]}`;
  }
}
